import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_8d2ho99', 'template_voop4u7', form.current, 'iTmvadtJOBsqWZ72S')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

      e.target.reset();
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
          <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>pjh843@gmail.com</h5>
            <a href="mailto:pjh843@gmail.com" target="_blank">Send a message</a>
          </article>
          <article className='contact__option'>
          <BsWhatsapp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <h5>+1 (825)712-1504</h5>
            <a href="https://api.whatsapp.com/send?phone=18257121504" target="_blank">Send a message</a>
          </article>
          </div>
            <form ref={form} onSubmit={sendEmail}>
              <input type="text" name='name' placeholder='Your Full Name' required />
              <input type="email" name='email' placeholder='Your Email' required />
              <textarea name="message" rows="7" placeholder='Your Message' required />
              <button type='submit' className='btn btn-primary'>Send Message</button>
            </form>
      </div>
    </section>
  )
}

export default Contact